import ApiService from '@/core/services/api.service'
import moment from 'moment'
import fileDownload from '@/utils/file-download'
import { makeToastSuccess, makeToastFaile } from '@/utils/common'

export const buildHistoryDateParams = (dpForm) => ({
  fromDate: dpForm.startDate
    ? moment(dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
    : '',
  toDate: dpForm.endDate
    ? moment(dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
    : '',
})

const parseBlobErrorMessage = async (blobData, fallback) => {
  if (!(blobData instanceof Blob)) {
    return fallback
  }
  try {
    const text = await blobData.text()
    const json = JSON.parse(text)
    return (
      [json.message, json.error, json.msg].find(
        (item) => typeof item === 'string' && item.trim(),
      ) || fallback
    )
  } catch (_) {
    return fallback
  }
}

export async function exportProductStockHistory(
  productId,
  { storeId, fromDate, toDate, productCode } = {},
) {
  const params = {}
  if (storeId) {
    params.storeId = storeId
  }
  if (fromDate) {
    params.fromDate = fromDate
  }
  if (toDate) {
    params.toDate = toDate
  }

  try {
    const response = await ApiService.get(
      `v1/product-stocks/${productId}/history/export`,
      {
        params,
        responseType: 'blob',
      },
    )

    const contentType = String(response.headers['content-type'] || '').toLowerCase()
    if (contentType.includes('application/json')) {
      const message = await parseBlobErrorMessage(response.data, 'Xuất Excel thất bại')
      makeToastFaile(message)
      return false
    }

    let fileName = `LichSuTonKho-${productCode || productId}-${moment().format(
      'YYYY-MM-DD HH:mm:ss',
    )}.xlsx`
    try {
      fileName = fileDownload.getFileName(response)
    } catch (_) {
      /* BE không gửi / CORS không expose Content-Disposition */
    }

    fileDownload.createFile(
      response.data,
      fileName,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    )
    makeToastSuccess('Đã tải file Excel')
    return true
  } catch (error) {
    const message = await parseBlobErrorMessage(
      error?.response?.data,
      'Xuất Excel không thành công',
    )
    makeToastFaile(message)
    return false
  }
}
